import { Trans, useTranslation } from 'react-i18next'
import {
  TranscriptionScriptBold,
  TranscriptionScriptBoldUnderline,
  TranscriptionScriptBox,
  TranscriptionScriptItalic,
  TranscriptionScriptItalicUnderline,
  TranscriptionScriptUl,
} from './styles'
import { FC } from 'react'

interface TranscriptionScriptProps {
  script: string
  scriptProps?: {
    lng?: string
    clientName?: string
    socialReferent?: string
    birthDay?: string
    [key: string]: string | undefined
  }
  components?: object
}

export const TranscriptionScript: FC<TranscriptionScriptProps> = ({
  script,
  scriptProps,
  components = {},
}) => {
  const { t } = useTranslation()
  const lng = scriptProps?.lng || undefined

  return (
    <Trans
      i18nkey={script}
      values={scriptProps}
      components={{
        italic: <TranscriptionScriptItalic />,
        italicUnderline: <TranscriptionScriptItalicUnderline />,
        boldUnderline: <TranscriptionScriptBoldUnderline />,
        bold: <TranscriptionScriptBold />,
        br: <br />,
        box: <TranscriptionScriptBox />,
        p: <p />,
        ol: <ol />,
        ul: <TranscriptionScriptUl />,
        li: <li />,
        u: <u />,
        ...components,
      }}
      defaults={t(script, { lng })}
    />
  )
}
